module.exports = __webpack_public_path__ + "static/media/quarteto_coliseu_3.b81063f9.jpg";